module.exports = __webpack_public_path__ + "tank.f4c9f45f2c4bb8af960f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/tank.png
// module id = 433
// module chunks = 1